import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ColumnPicker from './icon-column-picker.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ColumnPicker {...validProps} />;
}
SvgComponent.iconName = 'columnPicker';

/**
 * @deprecated This is a legacy icon
 */
export const ColumnPickerIcon = svgIconWrapper(SvgComponent);
